export default __webpack_public_path__ + "static/media/granville15.fb917490.jpg";